<template>
  <div class="select-outbound">
    <div v-if="!orderId" class="select-wrap">
      <div class="section">
        <div class="section-head">
          <div class="section-title">商品明细</div>
          <van-button
            type="primary"
            size="small"
            round
            @click="openProductSelect"
          >
            添加商品
          </van-button>
        </div>
        <div v-if="!selectedProducts.length" class="empty-tip">
          请选择要出库的商品
        </div>
        <div
          v-for="(item, idx) in selectedProducts"
          :key="item.productId || idx"
          class="select-goods-item"
        >
          <div class="select-goods-main">
            <div class="goods-name">{{ item.productName }}</div>
            <div class="select-goods-meta">
              ￥{{ formatAmount(item.retailPrice) }}
              <span v-if="item.stockNum != null">
                ｜库存 {{ item.stockNum }}
              </span>
            </div>
          </div>
          <div class="select-goods-ops">
            <div class="qty-ctrl">
              <van-button
                size="mini"
                icon="minus"
                :disabled="Number(item.orderNum) <= 1"
                @click="changeQty(idx, -1)"
              />
              <span class="qty-num">{{ item.orderNum }}</span>
              <van-button
                size="mini"
                icon="plus"
                @click="changeQty(idx, 1)"
              />
            </div>
            <van-icon
              name="delete-o"
              class="del-icon"
              @click="removeSelected(idx)"
            />
          </div>
        </div>
      </div>

      <div class="section">
        <div class="kv-row total-row">
          <span class="kv-label">合计</span>
          <span class="kv-value total">￥{{ formatAmount(selectTotalAmount) }}</span>
        </div>
        <div class="kv-row discount-row">
          <span class="kv-label">优惠金额</span>
          <van-field
            v-model="discountText"
            input-align="right"
            type="number"
            :border="false"
            class="discount-field"
          />
        </div>
        <div class="kv-row">
          <span class="kv-label">应付</span>
          <span class="kv-value payable">￥{{ selectPayAmountText }}</span>
        </div>
      </div>

      <div class="section">
        <div class="section-head">
          <div class="section-title">出库备注</div>
          <span class="remark-optional">选填</span>
        </div>
        <van-field
          v-model="remark"
          class="remark-field"
          type="textarea"
          rows="3"
          autosize
          maxlength="200"
          show-word-limit
          :border="false"
          placeholder="请输入备注"
        />
      </div>

      <div class="bottom-bar">
        <van-button
          type="primary"
          block
          round
          color="#07c160"
          :loading="creating"
          @click="confirmSelect"
        >
          确认出库
        </van-button>
        <van-button plain block round class="rescan-btn" @click="$emit('back')">
          返回
        </van-button>
      </div>
    </div>

    <outbound-pay
      v-else
      :order-id="orderId"
      :order-info="orderInfo"
      :products="products"
      back-text="重新选择"
      :remark="remark"
      @back="backFromPay"
    />

    <NewProductSelect
      type="retail"
      columnsType="checkbox"
      :scId="scId"
      :visible="showProductSelect"
      @confirm="onSelectProductConfirm"
    />
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  createSelfMachineOrder,
  cancelSelfMachineOrder,
} from "../../../service/api/retail/manual-outbound";
import NewProductSelect from "../../../components/newProductSelect.vue";
import { reqSc } from "../../../service/api/product";
import OutboundPay from "./outbound-pay.vue";
import {
  formatAmount,
  getUserInfo,
  loadOutboundOrder,
} from "./outbound-common";
import { add, ge, gt, mul, sub, toFixed } from "../../../utils";

export default {
  name: "select-outbound",
  components: {
    OutboundPay,
    NewProductSelect,
  },
  data() {
    return {
      creating: false,
      orderId: "",
      merchId: "",
      orderInfo: {},
      products: [],
      scId: "",
      selectedProducts: [],
      showProductSelect: false,
      discountText: "",
      remark: "",
    };
  },
  computed: {
    selectTotalAmount() {
      return this.selectedProducts.reduce((sum, item) => {
        return add(sum, mul(item.retailPrice || 0, item.orderNum || 0));
      }, 0);
    },
    selectPayAmountText() {
      return toFixed(sub(this.selectTotalAmount, this.discountText || 0), 2);
    }
  },
  created() {
    const user = getUserInfo();
    this.merchId = user.merchId ? String(user.merchId) : "";
    if (!this.merchId) {
      Toast.fail("未获取到商家信息，请重新登录");
      this.$emit("back");
      return;
    }
    this.autoSelectWarehouse();
  },
  methods: {
    formatAmount,
    /** 有默认仓库用默认，否则用第一条 */
    async autoSelectWarehouse() {
      try {
        const res = await reqSc({
          available: true,
          pageIndex: 1,
          pageSize: 15,
          merchId: this.merchId,
        });
        const list = (res && res.data && res.data.datas) || [];
        if (!list.length || !list[0].id) {
          Toast.fail("未获取到仓库，请稍后重试");
          return;
        }
        const defaultSc = list.find((item) => item.isDefault == 1);
        this.scId = (defaultSc || list[0]).id;
      } catch (e) {
        Toast.fail("获取仓库失败，请稍后重试");
      }
    },
    openProductSelect() {
      if (!this.scId) {
        Toast.fail("未获取到仓库，请稍后重试");
        this.autoSelectWarehouse();
        return;
      }
      this.showProductSelect = true;
    },
    onSelectProductConfirm(row) {
      this.showProductSelect = false;
      if (!row || !row.length) {
        return;
      }
      row.forEach((el) => {
        const productId = el.productId || el.id;
        if (!productId) {
          return;
        }
        const exist = this.selectedProducts.find(
          (item) => item.productId === productId
        );
        const isCz =
          el.externalCode && String(el.externalCode).includes("CZ");
        if (exist) {
          if (isCz) {
            return;
          }
          exist.orderNum = Number(exist.orderNum || 0) + 1;
          return;
        }
        this.selectedProducts.push({
          productId,
          productName: el.productName || el.name || "",
          retailPrice: Number(el.retailPrice || el.taxPrice || 0),
          stockNum: el.stockNum,
          externalCode: el.externalCode || "",
          orderNum: 1,
        });
      });
    },
    changeQty(index, delta) {
      const item = this.selectedProducts[index];
      if (!item) {
        return;
      }
      if (item.externalCode && String(item.externalCode).includes("CZ")) {
        return;
      }
      const next = Number(item.orderNum || 0) + delta;
      if (next < 1) {
        return;
      }
      this.$set(item, "orderNum", next);
    },
    removeSelected(index) {
      this.selectedProducts.splice(index, 1);
    },
    /** 选品确认：先创建自助机订单，再走原来的查单/出库支付 */
    async confirmSelect() {
      if (!this.scId) {
        Toast.fail("未获取到仓库，请稍后重试");
        this.autoSelectWarehouse();
        return;
      }
      if (!this.selectedProducts.length) {
        Toast.fail("请选择要出库的商品");
        return;
      }
      const invalid = this.selectedProducts.find(
        (item) => !item.productId || Number(item.orderNum) <= 0
      );
      if (invalid) {
        Toast.fail("商品数量必须大于0");
        return;
      }
      const discountText = String(this.discountText || "").trim();
      if (gt(discountText || 0, 0) && ge(discountText, this.selectTotalAmount)) {
        Toast.fail("优惠金额不能超过合计，至少需保留 0.01 元");
        return;
      }
      const user = getUserInfo();
      const merchId = this.merchId || (user.merchId ? String(user.merchId) : "");
      if (!merchId) {
        Toast.fail("未获取到商家信息，请重新登录");
        return;
      }
      const products = this.selectedProducts.map((item) => {
        const qty = Number(item.orderNum);
        const price = Number(item.retailPrice) || 0;
        const product = {
          productId: item.productId,
          oriPrice: price,
          taxPrice: price,
          discountRate: 0,
          orderNum: qty,
          totalAmount: (price * qty).toFixed(2),
        };
        if (item.externalCode && String(item.externalCode).includes("CZ")) {
          product.externalCode = item.externalCode;
        }
        return product;
      });
      this.creating = true;
      try {
        const payload = {
          scId: this.scId,
          merchid: merchId,
          merchId,
          manualOutbound: true,
          paymentDate: new Date().toISOString().slice(0, 10),
          price: this.selectTotalAmount,
          products,
        };
        if (discountText && gt(discountText, 0)) {
          payload.discountAmount = toFixed(discountText, 2);
        }
        const remark = String(this.remark || "").trim();
        if (remark) {
          payload.remark = remark;
        }
        const res = await createSelfMachineOrder(payload);
        const data = (res && res.data) || {};
        const orderId = data.sheetId || data.orderId || "";
        if (!orderId) {
          Toast.fail("下单失败：未返回订单号");
          return;
        }
        const loaded = await loadOutboundOrder(String(orderId));
        this.orderInfo = loaded.orderInfo;
        this.products = loaded.products;
        this.orderId = String(orderId);
      } catch (e) {
        Toast.fail((e && (e.msg || e.message)) || "下单失败，请重试");
      } finally {
        this.creating = false;
      }
    },
    async backFromPay() {
      if (this.orderId) {
        try {
          await cancelSelfMachineOrder(this.orderId);
        } catch (e) {
          // 关单失败不阻断返回
        }
      }
      this.orderId = "";
      this.orderInfo = {};
      this.products = [];
    },
  },
};
</script>

<style scoped lang="less">
.select-wrap {
  padding: 12px 12px 120px;
}

.section {
  background: #fff;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 10px;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  .section-title {
    margin-bottom: 0;
  }
}

.kv-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 14px;
}

.kv-label {
  color: #969799;
}

.kv-value {
  color: #323233;
}

.total-row .total {
  color: #07c160;
  font-size: 20px;
  font-weight: 700;
}

.discount-row {
  align-items: center;
}

.discount-row .kv-label {
  flex-shrink: 0;
}

.discount-field {
  padding: 0;
  flex: 1;
  max-width: 160px;
  background: transparent;
}

.discount-field ::v-deep .van-field__control {
  text-align: right;
  font-size: 14px;
  color: #323233;
}

.payable {
  color: #323233;
  font-weight: 600;
}

.remark-optional {
  font-size: 12px;
  font-weight: 400;
  color: #c8c9cc;
}

.remark-field {
  margin-top: 2px;
  padding: 10px 12px 8px;
  background: #f7f8fa;
  border-radius: 8px;
}

.remark-field ::v-deep .van-field__control {
  min-height: 72px;
  font-size: 14px;
  line-height: 22px;
  color: #323233;
}

.remark-field ::v-deep .van-field__control::placeholder {
  color: #c8c9cc;
}

.remark-field ::v-deep .van-field__word-limit {
  margin-top: 6px;
  font-size: 12px;
  line-height: 16px;
  color: #c8c9cc;
}

.empty-tip {
  padding: 24px 0;
  text-align: center;
  font-size: 13px;
  color: #c8c9cc;
}

.select-goods-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f2f3f5;

  &:last-child {
    border-bottom: none;
  }
}

.select-goods-main {
  flex: 1;
  min-width: 0;
  padding-right: 8px;
}

.goods-name {
  font-size: 14px;
  color: #323233;
}

.select-goods-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}

.select-goods-ops {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.qty-ctrl {
  display: flex;
  align-items: center;
}

.qty-num {
  min-width: 24px;
  text-align: center;
  font-size: 14px;
  color: #323233;
}

.del-icon {
  margin-left: 10px;
  font-size: 18px;
  color: #ee0a24;
}

.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
}

.rescan-btn {
  margin-top: 8px;
}
</style>
